let info = {
  name: "Carlos Yonusg",
  logo_name: "Carlos, Yonusg",
  flat_picture: require("./src/assets/me.jpg"),
  config: {
    use_cookies: true,
    navbar: {
      blur: false
    }
  },
  description:
    `Hello, I'm Carlos Yonusg, a seasoned Computer Engineer with over a decade of extensive experience in software development.</br> </br>My expertise encompasses Front-end Development, Back-end Development, and Mobile App Development. I believe in the power of code to unite and innovate in our digital era.
Throughout my career, I've contributed to innovative software projects, driving the creation of cutting-edge technological solutions that shape the future.</br></br>My deep knowledge in various programming languages and frameworks ensures that I deliver high-quality, scalable, and efficient software.
Explore my journey where technology meets creativity, and each line of code drives progress. Whether you need a dynamic mobile application, a user-friendly website, or a robust backend system, I have the skills and experience to turn your ideas into reality.`,
  links: {
    linkedin: "https://www.linkedin.com/in/cayonusg/",
    github: "https://github.com/cyonusg",
    behance: "",
    resume: "",
  },
  education: [  
    {
      name: "Colegio Universitario de Caracas",
      place: "Caracas, Venezuela",
      date: "Octubre, 2009 - Julio, 2013",
      degree: "Informatics Engineer",
      gpa: "??",
      description:
        "",
      skills: [
        "Software Engineering",
        "web programming",
        "UI/UX design",
        "Front-end developing",
      ]
    },
  ],
  experience: [
    {
      name: "Accenture",
      img: require("./src/assets/clients/accenture.svg"),
      place: "Santiago - Chile",
      position: "Senior Full-Stack Developer",
      description:
        "",
      skills: [".NET", "Angular", "Azure", "React", "TypeSript", "C#" ,  "HTML", "CSS", "Agile"]
    },
    {
      name: "ThougthWorks",
      img: require("./src/assets/clients/thoughtworks.png"),
      place: "Santiago - Chile",
      position: "Senior Full-Stack Developer",
      description:
        "",
      skills: [".NET", "Angular", "Azure", "React", "TypeSript", "C#" ,  "HTML", "CSS", "Agile"]
    },
    {
      name: "Seguros Sura",
      img: require("./src/assets/clients/segurossura.png"),
      place: "Santiago - Chile",
      position: "Senior Full-Stack Developer",
      description:
        "",
      skills: [".NET", "Angular", "Azure", "React", "TypeSript", "C#" ,  "HTML", "CSS", "Agile"]
    },
    {
      name: "ACL.SPA (IBM)",
      img: require("./src/assets/clients/acl.png"),
      place: "Santiago - Chile",
      position: "Senior Full-Stack Developer",
      description:
        "",
      skills: [".NET", "Angular", "Microservices", "SQL server", "TypeSript", "C#" ,  "HTML", "CSS", "Agile"]
    },
    {
      name: "TacTech.spa",
      img: require("./src/assets/clients/tactech.png"),
      place: "Santiago - Chile",
      position: "Full-Stack developer",
      description:
        "",
      skills: ["AWS", "NodeJs", "Graphql", "PostgreSql", "DynamoDb", "NextJs", "Docker", "Microservice","Typescript", "Scrum"]
    },
    {
      name: "rflex.spa",
      img: require("./src/assets/clients/rflex.png"),
      place: "Santiago - Chile",
      position: "Senior Developer",
      description: "",
      skills: ["Ionic", "VueJs", "IOS", "Android", "HTML", "CSS"]
    },
    {
      name: "Logos.Corp",
      img: require("./src/assets/clients/logosCorp.svg"),
      place: "Caracas - Venezuela",
      position: "Semi-Senior Developer",
      description: "",
      skills: ["Laravel", "Vue", "HTML", "CSS", "PHP", "JavaScript"]
    },
    {
      name: "Arigato Studio",
      img: require("./src/assets/clients/arigato.jpeg"),
      place: "Caracas - Venezuela",
      position: "Semi-Senior Developer",
      description: "",
      skills: ["Wordpress","Laravel", "Angular", "HTML", "CSS", "PHP", "JavaScript"]
    },
    {
      name: "Analiticom",
      img: require("./src/assets/clients/analiticom.png"),
      place: "Caracas - Venezuela",
      position: "Junior Developer",
      description: "",
      skills: ["Wordpress","Laravel", "HTML", "CSS", "PHP", "JavaScript"]
    },
  ],
  skills: [
    {
      title: "Language",
      info: [
        "C#","Python","Javascript","TypeScript","PHP"
      ],
      icon: "fa fa-code"
    },
    {
      title: "FrontEnd",
      info: [
        "Angular","Vue","React","Nextjs"],
      icon: "fa fa-cubes"
    },
    {
      title: "BackEnd",
      info: [
        ".Net","NodeJS","NestJS","FastApi","Laravel"],
      icon: "fa fa-cubes"
    },
    {
      title: "Cloud",
      info: ["AWS", "Azure"],
      icon: "fa fa-pencil-square-o"
    },
    {
      title: "Databases",
      info: ["Postgres", "Mysql", "SQL server", "Oracle", "MongoDB","DynamoDB"],
      icon: "fas fa-laptop-code"
    },
    {
      title: "Other Skills",
      info: ["Git", "Docker", "Scrum", "Photoshop", "XD"],
      icon: "fas fa-laptop-code"
    },
  ],
  applications:[
    /*Cronometro*/
    {
      Name: "Cronometer Hybrid Monkey Competitions",
      title: "Hybrid Monkey first Edition",
      pictures: [
        {
          img: require("./src/assets/portfolio/monkeyHybrid/firstEdition.png")
        },
        {
          img: require("./src/assets/portfolio/monkeyHybrid/firstEdition4.png")
        },
        {
          img: require("./src/assets/portfolio/monkeyHybrid/firstEdition3.png")
        },
        {
          img: require("./src/assets/portfolio/monkeyHybrid/firstEdition1.jpg")
        },
        {
          img: require("./src/assets/portfolio/monkeyHybrid/firstEdition2.jpg")
        },
      ],
      technologies: ["JS", "vue"],
      category: "Web App",
      date: "febrero, 2025",
      github:"",
      visit: "",
      description:
        `
      A custom application was designed and implemented to track team participation on a centralized screen, ensuring transparency and speed in awarding podiums. Additionally, a real-time leaderboard was developed, dynamically updating as participants completed their challenges.
      As an added value, the platform also provided visibility for event sponsors by integrating their digital platforms directly into the attendees' phones, maximizing reach and engagement.
        `
    },
    /*Intranet*/
    {
      Name: "Intranet BICE",
      title: "Intranet BICE",
      pictures: [
        {
          img: require("./src/assets/portfolio/bice/1.jpg")
        }
      ],
      technologies: ["C#", ".NET","Angular", "JS"],
      category: "Web App",
      date: "October, 2022",
      github:"",
      visit: "",
      description:
        `
        Transformative Intranet System Development for Leading Insurance Company in Chile.</br>
        Embark on a transformative journey with our development of a state-of-the-art Intranet system for a prominent insurance client in Chile. Our primary goal was to streamline the management of the entire insurance team through a dynamic and efficient platform.</br>
        This innovative Intranet solution empowered seamless self-management for onboarding and offboarding processes, as well as efficiently handling all aspects related to employee benefits. Experience the evolution of employee engagement through cutting-edge innovation, where every interaction becomes an opportunity for growth and efficiency.
        `
    },
    /*Delitech*/
    {
      Name: "Delitech",
      title: "Delitech",
      pictures: [
        {
          img: require("./src/assets/portfolio/delitech/1.jpg")
        },
        {
          img: require("./src/assets/portfolio/delitech/2.jpg")
        }
      ],
      technologies: ["AWS", "JS","Typescript", "GraphQl"],
      category: "Mobile App",
      date: "October, 2020",
      github:"",
      visit: "https://delitech.app",
      description:`
      Delitech: Innovative Software for the Gastronomic Industry.</br>
      Discover Delitech, cutting-edge software designed specifically for the gastronomic industry. Our primary focus is revolutionizing sales channel management through a centralized platform. Additionally, we developed a fully customizable e-commerce solution seamlessly integrated with other Delitech services.</br>
      Over the course of two years, I dedicated myself to this project, from its inception to the MVP launch. I played a pivotal role in shaping architectural, functional, and non-functional decisions, ensuring a robust and efficient system.</br>
      Join the journey where innovation meets culinary excellence with Delitech.
      `
    },
    /*Rflex*/
    {
      Name: "Rflex - Mobile App",
      title: "Rflex - Mobile App",
      pictures: [
        {
          img: require("./src/assets/portfolio/rflex/1.jpg")
        },
      ],
      technologies: ["Vue", "Ionic", "Android/IOS"],
      category: "Mobile App",
      date: "October, 2019",
      github:"",
      visit: "https://rflex.io",
      description:`
      Rflex: Revolutionizing Healthcare Clinic Management.</br>
      Experience the impact of Rflex, an innovative application seamlessly connecting over a thousand users for efficient appointment scheduling in the dynamic realm of a healthcare clinic. Elevate workforce management by effortlessly tracking worked hours and ensuring accurate compensation for medical professionals.</br>
      Join the future of streamlined healthcare administration with Rflex – where connectivity meets precision.</br>
      `
    }
  ],
  webSites:[
    /*Alimentos Publio*/
    {
      Name: "Alimentos Publio",
      pictures: [
        {
          img: require("./src/assets/portfolio/publio/1.jpg")
        }
      ],
      technologies: ["Wordpress", "scss", "HTML/CSS", "PHP"],
      category: "Web site",
      date: "July, 2019",
      github:"",
      visit: "https://www.alimentospublio.com",
      description:
        "Explore a uniquely designed website, meticulously crafted to serve as an informative hub for a significant culinary venture in Venezuela's thriving food industry. Immerse yourself in a visually captivating experience that not only showcases the essence of the enterprise but also seamlessly communicates its story. From bespoke design elements to curated content, this website is a testament to our commitment to bringing your culinary vision to life. Join us on a virtual journey that goes beyond information – it's an immersive exploration of culinary excellence and innovation."
    },
    /*Tienda jeyra*/
    {
      Name: "tiendasjeyra",
      pictures: [
        {
          img: require("./src/assets/portfolio/jeyra/1.jpg")
        },
        {
          img: require("./src/assets/portfolio/jeyra/2.jpg")
        },
        {
          img: require("./src/assets/portfolio/jeyra/3.jpg")
        },
        {
          img: require("./src/assets/portfolio/jeyra/4.jpg")
        }
      ],
      technologies: ["Wordpress", "scss", "HTML/CSS", "PHP"],
      category: "Web site",
      date: "july, 2018 days",
      github: "",
      visit: "http://www.tiendasjeyra.com",
      description:
        "Dive into a uniquely crafted and self-administered WordPress website, designed to showcase the essence of a prominent children's clothing company with over 30 years of market expertise. Immerse yourself in the world of timeless fashion for little ones, where every click unveils the story of a brand deeply rooted in a legacy of over three decades. This website isn't just a digital presence; it's a dynamic canvas that brings decades of experience and a passion for children's fashion to life. Join us in celebrating the journey of style, quality, and innovation that defines this beloved brand."
    },
    /*Geohidra*/
    {
      Name: "geohidra",
      pictures: [
        {
          img: require("./src/assets/portfolio/geohidra/1.jpg")
        },
        {
          img: require("./src/assets/portfolio/geohidra/2.jpg")
        },
  
      ],
      technologies: ["Wordpress", "scss", "HTML/CSS", "PHP"],
      category: "Mobile App",
      date: "July, 2017",
      github:"",
      visit: "https://geohidra.com",
      description:
        "Dive into a tailored online experience with a self-administered WordPress website designed for a significant client specializing in the collection, processing, and interpretation of geotechnical, geological, and geophysical data. This powerhouse is dedicated to steering the course of engineering projects and environmental studies, both on land and in shallow and deep waters. Explore the digital gateway to a world where precision and innovation converge, unlocking the potential of geotechnical insights for sustainable engineering and environmental excellence."
    },
    /*Valentina tintori*/
    {
      Name: "Valentina Tintori",
      pictures: [
        {
          img: require("./src/assets/portfolio/valentina/1.jpg")
        },
        {
          img: require("./src/assets/portfolio/valentina/2.jpg")
        },
        {
          img: require("./src/assets/portfolio/valentina/3.jpg")
        }
      ],
      technologies: ["Wordpress", "scss", "HTML/CSS", "PHP"],
      category: "Web site",
      date: "Oct, 2017",
      github: "",
      visit: "https://valentinatintori.com",
      description:
        "Step into a world of artistic expression with a uniquely crafted and self-administered WordPress website, showcasing the curation expertise of an art connoisseur based in vibrant Miami. Explore the digital gallery, where design meets innovation, and discover a curator's passion translated into a seamless online experience. This website isn't just a platform; it's a virtual journey through the captivating world of curated art. Immerse yourself in the intersection of creativity and technology, where every click opens a door to the boundless beauty curated by a Miami-based art aficionado."
    },
    /*Glameglat*/
    {
      Name: "Glameclat",
      pictures: [
        {
          img: require("./src/assets/portfolio/glameclat/1.jpg")
        },
        {
          img: require("./src/assets/portfolio/glameclat/2.jpg")
        },
        {
          img: require("./src/assets/portfolio/glameclat/3.jpg")
        }
      ],
      technologies: ["Wordpress", "scss", "HTML/CSS", "PHP"],
      category: "WebSites",
      date: "Aug, 2016",
      github: "",
      visit: "https://glameclat.com",
      description:
        "Explore a captivating online experience with a meticulously designed and self-administered WordPress website, crafted for a prominent fragrance retailer in the reseller industry. Immerse yourself in the world of scents, where artful design meets the latest in digital innovation. This platform transcends the ordinary – it's not just a website; it's a dynamic channel that redefines the art of selling fragrances. Journey through the aromatic universe of our reseller perfumery, where each visit becomes a sensorial adventure, and every click opens a door to the essence of luxury and sophistication."
    }
  ],
};

export default info;
